import { render } from "./SwiperComponent.vue?vue&type=template&id=47a9a462&scoped=true"
import script from "./SwiperComponent.vue?vue&type=script&lang=js"
export * from "./SwiperComponent.vue?vue&type=script&lang=js"

import "./SwiperComponent.vue?vue&type=style&index=0&id=47a9a462&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47a9a462"]])

export default __exports__